"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var multiStream_1 = __importDefault(require("../styles/multiStream"));
function useLayouts(props) {
    var layout = props.layout, numberOfRemoteStreams = props.numberOfRemoteStreams, width = props.width, height = props.height;
    var styles = react_1.useCallback(function () {
        return multiStream_1.default(numberOfRemoteStreams, layout, width, height);
    }, [
        layout,
        numberOfRemoteStreams,
        width,
        height
    ])();
    return {
        styles: styles,
    };
}
exports.default = useLayouts;
